import { AbilityContext } from 'permissions/AbilityContext';
import { useContext } from 'react';

export const useAbility = () => {
  const ability = useContext(AbilityContext);

  return ability;
};
